import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";

@Injectable()

export class BulletinService {
    constructor(
        private http: HttpClient,
    ) {}

    getBulletin(idEleve: number, anneeScolaire: number, periode: number): Observable<any> {
        // ServiceExamen.searchExamenForEleve(eleve.id, selectedAnnee.id, periodeId
        return this.http.get(
            environment.proxyUrl + '/examen/searchExamenForEleve',
            {
                params: {
                  'params': JSON.stringify([idEleve, periode, anneeScolaire]),
                }
            })

    }

    /**
     * A appeler lors du passage en modification sur une évaluation : permet de récupérer les dernières valeurs et d'avoir la liste des mentions possibles.
     * @param idExamen
     * @param idEleve
     * @param idDiscipline
     * @param idCycle
     * @param idNiveau
     */
    getExamenResultatComplet(idExamen: number, idEleve: number, idDiscipline: number, idCycle: number, idNiveau: number, anneeScolaire: number) {
        return this.http.get(
            environment.proxyUrl + '/examen/searchExamenResultatEtExmenComplet',
            {
                params: {
                  'params': JSON.stringify([idExamen, idEleve, idDiscipline, idCycle, idNiveau, anneeScolaire]),
                }
            })
            /* Au retour, récuérer :
            * res.examen
            * res.examen.typeNotation (qui doit contenir les listes de mentions)
            */

    }
}


// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/shared/services/bulletin.service.ts